<template>
  <div>
    <div class="materials">
      <v-category-button v-for='material in materials'
        @click="setSearchType(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedSearchType == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

//  data: () => ({
//    materials: [
//      {id: 1, text: '教科書', type: 'publisher', disabled: false},
//      {id: 2, text: 'ゲットスルー2600', type: 'getThrough', disabled: false},
//    ]
//  }),

  computed: {
    materials() {
      return this.$store.state.master.allMaterials;
    },
    selectedSearchType() {
      return this.$store.state.conditions.selectedSearchType;
    }
  },

  // watch() {
  //   "$store.state.conditions.selectedSearchType"(value) {

  //   }
  // },

  methods: {
    setSearchType(index) {
      this.$store.commit('conditions/setSelectedSearchType', {
        searchType: index
      })
      // ゲットスルーが選択された時は単語/連語 選択は空にする
      if (index == 2 && this.$store.state.conditions.firstSelectedSearchType) {
        this.$store.commit('conditions/resetCheckListTarget', {})
        this.$store.commit('conditions/setFirstSelectedSearchType', {boolean: false})
      }
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

</style>
